/// <amd-module name="Feed/Legacy/Protocols/Npm/NpmPackagePeople" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import * as PackageResources from "Feed/Common/Resources";
import { IPerson } from "Feed/Legacy/Protocols/Common/IPerson";
import { PackageAttribute } from "Feed/Legacy/Protocols/Components/PackageAttribute";
import { PackagePerson } from "Feed/Legacy/Protocols/Components/PackagePerson";

export interface INpmPackagePeopleProps {
    pageContext: IVssPageContext;
    author: IPerson;
    contributors: IPerson[];
}

export class NpmPackagePeople extends React.PureComponent<INpmPackagePeopleProps> {
    public render(): JSX.Element {
        if (!this.props.author && !this.props.contributors) {
            return null;
        }

        return (
            <div className="npm-package-people">
                <PackageAttribute title={PackageResources.PackagePeople_Title}>
                    {this.props.author && (
                        <div>
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.PackagePeople_Author}
                            </div>
                            <PackagePerson pageContext={this.props.pageContext} person={this.props.author} />
                        </div>
                    )}
                    {this.props.contributors && (
                        <div>
                            <div className="package-group-spacer" />
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.NpmPackagePeople_Contributors}
                            </div>
                            {this.props.contributors.map((contributor: IPerson) => {
                                return (
                                    <PackagePerson
                                        pageContext={this.props.pageContext}
                                        key={contributor.name}
                                        person={contributor}
                                    />
                                );
                            })}
                        </div>
                    )}
                </PackageAttribute>
            </div>
        );
    }
}
